import apiClient from './ApiClient';

export class StockRepository {
	constructor(client) {
		this.client = client;
		this.basePath = '/api/stock';
	}

	/**
	 * Get stock details for a specific service item (product)
	 * @param {string} serviceItemId - Service item UUID
	 * @returns {Promise<Object>} Stock details including movements
	 */
	async getStock(serviceItemId) {
		return this.client.get(`${this.basePath}/${serviceItemId}`);
	}

	/**
	 * Get all low or out-of-stock products
	 * @returns {Promise<Array>} Array of low/out-of-stock products
	 */
	async getLowStock() {
		return this.client.get(`${this.basePath}/low-stock`);
	}

	/**
	 * Restock a product
	 * @param {string} serviceItemId - Service item UUID
	 * @param {Object} payload
	 * @param {number} payload.quantity - Quantity to add
	 * @param {string} [payload.reason] - Optional reason for restock
	 * @returns {Promise<Object>} Updated stock details
	 */
	async restock(serviceItemId, payload) {
		return this.client.post(`${this.basePath}/${serviceItemId}/restock`, payload);
	}
}

export default new StockRepository(apiClient);